import { User } from "../user/user.model";
import { BaseRate } from "./rate-base.model";
import { Client } from "../client/client.model";
import { Rate } from "./rate-type";
import { Carrier } from "../carrier/carrier.model";
import { ContainerName } from "../shared/container/container-name.type.const";
import { Location } from "../location/location.model";
import { RateFclFlatRoute } from "./rate-flat-route-list/rate-fcl-flat-route.model";
import { currencies } from "../shared/currencies/currencies.const";
import { AirWeightBracketPrices } from "app/shared/air-weight-bracket/air-weight-bracket-prices.model";

export class AirFlatRate extends BaseRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected equipment: ContainerName[] = [],
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected contractNumber?: string,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
    protected incoterms: string[] = [],
    protected flatRateRoutes?: RateFclFlatRoute[],
    public totalWeightPriceLt45?: number,
    public totalWeightPriceGt45?: number,
    public totalWeightPriceGt100?: number,
    public totalWeightPriceGt300?: number,
    public totalWeightPriceGt500?: number,
    public totalWeightPriceGt1000?: number,
    public availableOnline?: boolean,
    public weightBracketMargins?: AirWeightBracketPrices,
    public maxWeightPerShipment?: number,
    public maxWeightPerPiece?: number,
    public maxMeasurementPerShipment?: number,
    public maxMeasurementPerPiece?: number,
    public maxTaxWeight?: number,
    public maxLength?: number,
    public maxHeight?: number,
    public maxWidth?: number,
    public maxLWH?: number,
    public marginType?: string,
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public getCurrency() {
    return this.currency;
  }

  public getFlatRateRoutes() {
    return this.flatRateRoutes;
  }

  public setFlatRateRoutes(flatRateRoutes): void {
    this.flatRateRoutes = flatRateRoutes;
  }

  public getAvailableOnline(): boolean {
    return this.availableOnline;
  }

  /** Table methods */
  public get realOriginLocation(): Location {
    return this.flatRateRoutes.length
      ? this.flatRateRoutes[0].originLocation
      : null;
  }

  public get realDestinationLocation(): Location {
    return this.flatRateRoutes.length
      ? this.flatRateRoutes[0].destinationLocation
      : null;
  }

  public get currency(): string {
    return this.flatRateRoutes.length
      ? this.flatRateRoutes[0].currency
      : currencies.usd.value;
  }

  public getIncoterms(): string[] {
    return this.incoterms;
  }

  public setIncoterms(incoterms: string[]): void {
    this.incoterms = incoterms;
  }

  public isValid(): boolean {
    return !!this.name && !!this.carrier && !!this.validity;
  }
}
